declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    dataLayer: any[]
  }
}

export default function (args: object) {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push(args)
}
